export const redirect = (url) => {
  window.location.assign(url);
};

export const redirectToHref = (url) => {
  window.location.href = url;
};
